export default {
  methods: {
    // here we need to check if there are any filter params in the URL and
    // use them to filter the initial page load
    setFiltersFromQuery(model) {
      const { query } = this.$route;

      // page and search will always be the same params
      if (query.page) {
        this.$store.commit(`${model}/setPage`, query.page);
      }

      if (query.search) {
        this.$store.commit(`${model}/setSearchQuery`, query.search);
      }

      if (query.sortField && query.sortDir) {
        this.$store.commit(`${model}/setSortBy`, {
          direction: query.sortDir,
          field: query.sortField,
        });
      }

      // categories aren't necessarily categories, should it be more generic?
      if (query.categories) {
        this.$store.commit(
          `${model}/setFilterCategories`,
          query.categories.split(",")
        );
      }
    },
    getCurrentPageNumber(model) {
      return parseInt(this.$store.state[model].pagination.current_page);
    },
    updatePageQuery(model, page) {
      this.$store.commit(`${model}/setPage`, page);
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.page = page;
      this.$router.replace({ query: queries });
      this.$route.query.page = page;
    },
    updateSearchQuery(term) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      if (term == null) {
        delete queries.search
      } else {
        queries.search = term;
      }
      this.$router.replace({ query: queries });
    },
  },
};
